// extracted by mini-css-extract-plugin
export default {"root":"BlogMemoryCta_root__-oUbZ","script":"BlogMemoryCta_script__Hf2z7"};